import template from './account-registration.html';
import controller from './account-registration.controller';
import './account-registration.scss';

let AccountRegistrationComponent = {
  bindings: {
    profiles: '<',
    invitations: '<',
    countries: '<'
  },
  template,
  controller
};

export default AccountRegistrationComponent;



// WEBPACK FOOTER //
// ./src/app/pages/account-registration/account-registration.component.js